export default (name) => {
  let tokens = name.split(' ');

  if (tokens.length === 1) {
    return name;
  }

  return tokens.slice(0, -1).join(' ');
}
